import React, { useCallback, useContext } from "react";
import SearchSelect from "../ui-components/SearchSelect";
// import { debounce } from "lodash";
import getProductsOptions from "../utils/getProductsOptions";
import useCountryAxiosInstance from "../hooks/useCountryAxiosInstance";
import { NotificationsContext } from "../ui-components/Notifications";
import { useIntl } from "react-intl";

const buildBody = (text, limit = 50, lines, bdgtCls) => {
  return {
    filters: {
      logic: "and",
      filters: [
        {
          column: "prezzo",
          operator: ">",
          value: 0,
        },
        {
          logic: "or",
          filters: [
            {
              column: "art_cod",
              value: `%${text}%`,
              operator: "ilike",
            },
            {
              column: "art_des_cmpy",
              value: `%${text}%`,
              operator: "ilike",
            },
          ],
        },
        ...(lines && lines.length > 0
          ? [
              {
                column: "prod_line_cod",
                operator: "in",
                value: lines,
              },
            ]
          : []),
        ...(bdgtCls && bdgtCls.length > 0
          ? [
              {
                column: "bdg_cls_cod",
                operator: "in",
                value: bdgtCls,
              },
            ]
          : []),
      ],
    },
    ordering: {
      fields: [
        {
          column: "art_des_cmpy",
          orderDirection: "asc",
        },
      ],
    },
    limit: limit,
    offset: 0,
  };
};

const SelectProduct = ({
  value,
  onChange,
  location,
  businessId,
  includeInactive = false,
  noZeroPrice = false,
  isMulti = false,
  lines,
  bdgtCls,
  disabled,
  includeKColorProducts= false,
}) => {
  const apiRequest = useCountryAxiosInstance();
  const { push } = useContext(NotificationsContext);
  const intl = useIntl();
  // eslint-disable-next-line
  const loadProductOptions = useCallback(
    async (text, callback) => {
      let products;
      let kColorProducts = [];
      try {
        if (includeKColorProducts) {
          const config = {
            publicRequest: true,
          };
          kColorProducts = await apiRequest.get("/kcolors/products", {}, config)
          kColorProducts = kColorProducts.filter(kColorProduct =>
            kColorProduct.des_prod_comm.toLowerCase().includes(text.toLowerCase()) ||
            kColorProduct.cod_prod_comm.toLowerCase().includes(text.toLowerCase())
          );
        }

        if (noZeroPrice || lines || bdgtCls) {
          const body = buildBody(text, 50, lines, bdgtCls);
          const response = await apiRequest.post("/products/all", body);
          products = response.items;
          callback(getProductsOptions(products,  kColorProducts, true));
        } else {
          // build params
          const params = {
            art_cod: text,
            art_des_cmpy: text,
            like: "art_des_cmpy,art_cod",
          };
          if (location === "OpenBlock") params.business_id = businessId;
          if (!includeInactive) params.active = 1;

          // perform request
          products = await apiRequest.get("/products", { params });
        }

        callback(getProductsOptions(products, kColorProducts, true));
      } catch (error) {
        console.log(error)
        push({
          title: intl.formatMessage({ id: "server_error" }),
          type: "error",
        });
      }
    },
    [
      push,
      intl,
      apiRequest,
      businessId,
      noZeroPrice,
      includeInactive,
      lines,
      bdgtCls,
      includeKColorProducts
    ]
  );
  return (
    <SearchSelect
      isDisabled={disabled}
      label="Select product"
      loadOptions={loadProductOptions}
      value={value}
      cacheOptions={false}
      onChange={onChange}
      defaultOptions={
        isMulti ? [] : value ? [{ label: "Remove", value: "" }] : []
      }
      isMulti={isMulti}
      CustomOption={({ data, innerProps, innerRef }) => {
        const { object, label, secondaryLabel } = data;
        return (
          <article
            ref={innerRef}
            className="py-2 px-3 cursor-pointer hover:bg-blue-50"
            {...innerProps}
          >
            <p className="font-semibold text-sm">{label}</p>
            <p className={!object ? "text-sm" : "text-xs"}>{secondaryLabel}</p>
          </article>
        );
      }}
    />
  );
};

export default SelectProduct;
